import { formatRelativeTime } from '../../../utils/dateUtils';

interface BookmarkMetaProps {
  domain: string;
  url: string;
  readTimeText: string;
  time?: number;
  author?: string;
  estimatedTimeRemaining?: number;
  estimatedTotalTime?: number;
  /**
   * When true, the author is omitted from the byline. Used by the 3-column
   * layout where the narrow list column can't accommodate the author without
   * overflowing.
   */
  hideAuthor?: boolean;
}

function BookmarkMeta({
  domain,
  url,
  readTimeText,
  time,
  author,
  hideAuthor = false,
}: BookmarkMetaProps) {
  return (
    <div className="bookmark-byline truncate">
      {domain && (
        <span key="domain" title={url} className="text-bookmark-meta">
          {domain}
        </span>
      )}
      {author && !hideAuthor && (
        <span key="author" className="text-bookmark-meta">
          {' '}
          &middot; {author.length > 24 ? `${author.slice(0, 24)}...` : author}
        </span>
      )}

      {readTimeText && (
        <span key="readTime" className="text-bookmark-meta">
          {' '}
          &middot; {readTimeText}
        </span>
      )}
      {time && (
        <span key="date" className="text-bookmark-date hidden md:inline">
          {' '}
          &middot; {formatRelativeTime(time)}
        </span>
      )}
    </div>
  );
}

export default BookmarkMeta;
